module.exports = __webpack_public_path__ + "img/country.1e5759f3.jpg";